var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal modal_size", attrs: { id: "modal" } },
    [
      _c(
        "a",
        {
          staticClass: "ui_close",
          attrs: { href: "javascript:", type: "button", rel: "modal:close" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
      ),
      _vm._v(" "),
      _c("dl", { staticClass: "modal_content alert_msg " }, [
        _c(
          "dt",
          { staticClass: "ellipsis" },
          [
            _vm._t("header", [
              _vm._v(
                "\n                    TrustNet Solution needs to be installed!\n                "
              )
            ])
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_modal_wrap set_2" }, [
        _c("div", { staticClass: "btn_right" }, [
          _c(
            "a",
            {
              staticClass: "btn_white",
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn_blue",
              attrs: {
                href: "/static/setup/TrustNet_Cert_WEBCLIENT_v1.0.0.9.exe"
              },
              on: { click: _vm.download }
            },
            [_vm._v("\n                    Download\n                ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v("\n                If automatic installation does not work,"),
      _c("br"),
      _vm._v(
        "\n                please manually download the plugin and install it."
      ),
      _c("br"),
      _vm._v(
        "\n                After the installation, please restart the browser.        \n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0454893e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0454893e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/certificate/CertInstallPopup.vue
// module id = IaZv
// module chunks = 0